import React from "react";
import { Route, Switch } from "react-router";
import * as Pages                                         from "../infrastructure/views";
import Layout                                             from "../infrastructure/layout";
import DasboardLayout                                     from "../infrastructure/views/dashboard/layout";
import * as DasPages                                      from "../infrastructure/views/dashboard/pages"
import { useRouterResources, useRouter, useTranslate }    from "../hooks/use";
import { PrivateRoute, PublicRoute }                      from "../shared/hoc/index";

const ApplicationRouter = () => {
  const router = useRouter();
  const resource = useRouterResources({ route: router.route });
  const t = useTranslate();

  return (
    <Switch>
      <PublicRoute
        exact
        path={["/"]}
        component={(routeProps) => (
          <Layout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <Pages.Landing resource={resource} {...routeProps} />
          </Layout>
        )}
      />
      <PublicRoute
        exact
        path={["/services","/servis"]}
        component={(routeProps) => (
          <Layout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <Pages.Services resource={resource} {...routeProps} />
          </Layout>
        )}
      />
      <PublicRoute
        exact
        path={["/services/:details","/servis/:details"]}
        component={(routeProps) => (
          <Layout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <Pages.SectorsDetails resource={resource} {...routeProps} />
          </Layout>
        )}
      />
      <PublicRoute
        exact
        path={["/sectors","/sector"]}
        component={(routeProps) => (
          <Layout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <Pages.Sectors resource={resource} {...routeProps} />
          </Layout>
        )}
      />
        <PublicRoute
        exact
        path={["/sectors/:details","/sectors/:details"]}
        component={(routeProps) => (
          <Layout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <Pages.Sectors resource={resource} {...routeProps} />
          </Layout>
        )}
      />
      <PublicRoute
        exact
        path={["/blogs","/blog"]}
        component={(routeProps) => (
          <Layout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <Pages.Blogs resource={resource} {...routeProps} />
          </Layout>
        )}
      />
        <PublicRoute
        exact
        path={["/blog/:details","/blog/:details"]}
        component={(routeProps) => (
          <Layout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <Pages.BlogsDetails resource={resource} {...routeProps} />
          </Layout>
        )}
      />
      <PublicRoute
        exact
        path={["/about"]}
        component={(routeProps) => (
          <Layout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <Pages.About resource={resource} {...routeProps} />
          </Layout>
        )}
      />
        <PublicRoute
        exact
        path={["/about/:details"]}
        component={(routeProps) => (
          <Layout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <Pages.About resource={resource} {...routeProps} />
          </Layout>
        )}
      />
      <PublicRoute
        exact
        path={["/contact","/contacts"]}
        component={(routeProps) => (
          <Layout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <Pages.Contact resource={resource} {...routeProps} />
          </Layout>
        )}
      />
        <PublicRoute
        exact
        path={["/contact/:details","/contact/:details"]}
        component={(routeProps) => (
          <Layout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <Pages.Contact resource={resource} {...routeProps} />
          </Layout>
        )}
      />
      
      <PrivateRoute
        exact
        path={["/panel","/dash"]}
        component={(routeProps) => (
          <DasboardLayout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <Pages.Dasboard resource={resource} {...routeProps} />
          </DasboardLayout>
        )}
      />
      <PrivateRoute
        exact
        path={["/panel/main","/panel/mains"]}
        component={(routeProps) => (
          <DasboardLayout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <DasPages.Main resource={resource} {...routeProps} />
          </DasboardLayout>
        )}
      />
      <PrivateRoute
        exact
        path={["/panel/landing-page","/panel/landingpage"]}
        component={(routeProps) => (
          <DasboardLayout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <DasPages.LandingPage resource={resource} {...routeProps} />
          </DasboardLayout>
        )}
      />
      <PrivateRoute
        exact
        path={["/panel/service","/panel/services"]}
        component={(routeProps) => (
          <DasboardLayout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <DasPages.Services resource={resource} {...routeProps} />
          </DasboardLayout>
        )}
      />
      <PrivateRoute
        exact
        path={["/panel/consultancy"]}
        component={(routeProps) => (
          <DasboardLayout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <DasPages.Consultancy resource={resource} {...routeProps} />
          </DasboardLayout>
        )}
      />
      <PrivateRoute
        exact
        path={["/panel/sectors","/panel/sectors"]}
        component={(routeProps) => (
          <DasboardLayout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <DasPages.Sectors resource={resource} {...routeProps} />
          </DasboardLayout>
        )}
      />
      <PrivateRoute
        exact
        path={["/panel/contact","/panel/contacts"]}
        component={(routeProps) => (
          <DasboardLayout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <DasPages.Contact resource={resource} {...routeProps} />
          </DasboardLayout>
        )}
      />
      <PrivateRoute
        exact
        path={["/panel/blog","/panel/blogs"]}
        component={(routeProps) => (
          <DasboardLayout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <DasPages.Blog resource={resource} {...routeProps} />
          </DasboardLayout>
        )}
      />
      <PublicRoute
        exact
        path={["/admin","/sign-in"]}
        component={(routeProps) => (
            <Pages.SignIn resource={resource} {...routeProps} />
        )}
      />
      <PrivateRoute
        exact
        path={["/dashboard"]}
        component={(routeProps) => (
          <DasboardLayout
            title={router.route.title}
            route={router.route}
            resource={resource}
            {...routeProps}
          >
            <Pages.Dasboard resource={resource} {...routeProps} />
          </DasboardLayout>
        )}
      />
      <Route
        path={["*"]}
        render={(routeProps) => (
          <Pages.ErrorPage
            info={"Wrong path"}
            errorLocation={"Application"}
            error={t("Error_Page_404_Error_Label")}
            status={404}
            statusText={t("Error_Page_404_Error_Title")}
            {...routeProps}
          />
        )}
      />
    </Switch>
  );
};

export default ApplicationRouter;
